/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import flatten from 'lodash.flatten';
import {
    ActiveLearningFilterItem,
    QnaMakerFilterItem,
    QuestionsBeingEditedFilterItem,
    SmartSuggestionsFilterItem,
    UnsavedChangesFIlterItem
} from 'src/qnaMaker/appShell/qnaMakerEditPage/QnaMakerFiltersStore';
import { QnaMakerQnaSwagger } from 'src/qnaMaker/core/services/qnas/QnaMakerAssetsSwaggers';

export const applySourcesFilter = (appliedSourcesFilters: QnaMakerFilterItem[], qnaPair: QnaMakerQnaSwagger): boolean =>
    !appliedSourcesFilters.length ||
    appliedSourcesFilters.some(filter => filter.name === qnaPair.source || filter.name === qnaPair.sourceDisplayName);

export const applySuggestionFilter = (appliedSuggestionFilters: QnaMakerFilterItem[], qnaPair: QnaMakerQnaSwagger): boolean =>
    !appliedSuggestionFilters.length ||
    appliedSuggestionFilters.some(
        filter =>
            filter.id === ActiveLearningFilterItem &&
            qnaPair.activeLearningSuggestions.every(a => !a.totalAutoSuggestionCountFromGenerativeModel)
    ) ||
    appliedSuggestionFilters.some(
        filter =>
            filter.id === SmartSuggestionsFilterItem &&
            qnaPair.activeLearningSuggestions.every(a => a.totalAutoSuggestionCountFromGenerativeModel)
    );

export const applyMetadataFilter = (appliedMetadataFilters: QnaMakerFilterItem[], qnaPair: QnaMakerQnaSwagger): boolean =>
    !appliedMetadataFilters.length ||
    appliedMetadataFilters.some(filter =>
        Object.entries(qnaPair.metadata)
            .map(([k, v]) => `${k} : ${v}`)
            .includes(filter.id)
    );

export const applyQuestionFilter = (
    appliedQuestionFilters: QnaMakerFilterItem[],
    qnaPair: QnaMakerQnaSwagger,
    qnaPairToEditIds: number[],
    dirtyPairIds: number[]
): boolean =>
    !appliedQuestionFilters.length ||
    appliedQuestionFilters.some(filter => filter.id === UnsavedChangesFIlterItem && dirtyPairIds.includes(qnaPair.id)) ||
    appliedQuestionFilters.some(filter => filter.id === QuestionsBeingEditedFilterItem && qnaPairToEditIds.some(qid => qid === qnaPair.id));

export const getFlattenMetadata = (qnaPairsJson: QnaMakerQnaSwagger[]) =>
    new Set(flatten(qnaPairsJson.map(qna => Object.entries(qna.metadata).map(([k, v]) => `${k} : ${v}`))));
